import { gql } from 'graphql-tag';

import {
  AT_IMAGE_FRAGMENT,
  ENTRY_FRAGMENT,
  ENTRY_LAYOUT_FRAGMENT,
  ML_ACCORDION_FRAGMENT,
  ML_LAYOUT_CONTENT_FRAGMENT,
  ML_NAVTAB_FRAGMENT,
  OR_LESSON_SECTION_CONTAINER_FRAGMENT,
  REUSABLE_CONTENT_SECTION_FRAGMENT,
  SEO_FRAGMENT,
} from 'src/graphql/fragments/fragments';
import { GetArticleCollectionQuery } from 'src/graphql/generated/graphql';

export const GET_ARTICLE = gql`
  ${AT_IMAGE_FRAGMENT}
  ${ML_LAYOUT_CONTENT_FRAGMENT}
  ${ML_NAVTAB_FRAGMENT}
  ${ML_ACCORDION_FRAGMENT}
  ${OR_LESSON_SECTION_CONTAINER_FRAGMENT}
  ${SEO_FRAGMENT}
  ${ENTRY_LAYOUT_FRAGMENT}
  ${ENTRY_FRAGMENT}
  ${REUSABLE_CONTENT_SECTION_FRAGMENT}
  query getArticleCollection($preview: Boolean!, $slug: String!) {
    articleCollection(preview: $preview, limit: 1, where: { OR: [{ slug: $slug }] }) {
      items {
        sys {
          id
        }
        title
        description
        slug
        sectionListCollection(limit: 20, where: { sys: { id_exists: true } }) {
          items {
            ...OrLessonSectionContainerFragment
          }
        }
        seo {
          ...SeoFragment
        }
        contactUs {
          ...GetReusableContentSectionFragment
        }
      }
    }
  }
`;

export type Article = GetArticleCollectionQuery['articleCollection']['items'][0];
